import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7081/RpData";
	}
	addressSuggestion(e, t, r) {
		let i = this.baseUrl + "/AddressSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processAddressSuggestion(e)));
	}
	processAddressSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	getComparableProperties(e, t, r, i, a, o, s, c, l, u, d, p, m, h, g, _, v, y, b) {
		let x = this.baseUrl + "/GetComparableProperties";
		if (x += "?", e == null) throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
		if (x += "page=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
		if (x += "pageSize=" + encodeURIComponent(f(t)) + "&", r === null) throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
		if (r !== void 0 && (x += "propertyId=" + encodeURIComponent(f(r)) + "&"), i === null) throw new globalThis.Error("The parameter 'radius' cannot be null.");
		if (i !== void 0 && (x += "radius=" + encodeURIComponent(f(i)) + "&"), a === null) throw new globalThis.Error("The parameter 'minBedrooms' cannot be null.");
		if (a !== void 0 && (x += "minBedrooms=" + encodeURIComponent(f(a)) + "&"), o === null) throw new globalThis.Error("The parameter 'maxBedrooms' cannot be null.");
		if (o !== void 0 && (x += "maxBedrooms=" + encodeURIComponent(f(o)) + "&"), s === null) throw new globalThis.Error("The parameter 'minBathrooms' cannot be null.");
		if (s !== void 0 && (x += "minBathrooms=" + encodeURIComponent(f(s)) + "&"), c === null) throw new globalThis.Error("The parameter 'maxBathrooms' cannot be null.");
		if (c !== void 0 && (x += "maxBathrooms=" + encodeURIComponent(f(c)) + "&"), l === null) throw new globalThis.Error("The parameter 'minCarSpaces' cannot be null.");
		if (l !== void 0 && (x += "minCarSpaces=" + encodeURIComponent(f(l)) + "&"), u === null) throw new globalThis.Error("The parameter 'maxCarSpaces' cannot be null.");
		if (u !== void 0 && (x += "maxCarSpaces=" + encodeURIComponent(f(u)) + "&"), d === null) throw new globalThis.Error("The parameter 'propertyType' cannot be null.");
		if (d !== void 0 && (x += "propertyType=" + encodeURIComponent(f(d)) + "&"), p === null) throw new globalThis.Error("The parameter 'minPrice' cannot be null.");
		if (p !== void 0 && (x += "minPrice=" + encodeURIComponent(f(p)) + "&"), m === null) throw new globalThis.Error("The parameter 'maxPrice' cannot be null.");
		if (m !== void 0 && (x += "maxPrice=" + encodeURIComponent(f(m)) + "&"), h === null) throw new globalThis.Error("The parameter 'minLandArea' cannot be null.");
		if (h !== void 0 && (x += "minLandArea=" + encodeURIComponent(f(h)) + "&"), g === null) throw new globalThis.Error("The parameter 'maxLandArea' cannot be null.");
		if (g !== void 0 && (x += "maxLandArea=" + encodeURIComponent(f(g)) + "&"), _ === null) throw new globalThis.Error("The parameter 'latitude' cannot be null.");
		if (_ !== void 0 && (x += "latitude=" + encodeURIComponent(f(_)) + "&"), v === null) throw new globalThis.Error("The parameter 'longitude' cannot be null.");
		if (v !== void 0 && (x += "longitude=" + encodeURIComponent(f(v)) + "&"), y === null) throw new globalThis.Error("The parameter 'address' cannot be null.");
		y !== void 0 && (x += "address=" + encodeURIComponent(f(y)) + "&"), x = x.replace(/[?&]$/, "");
		let S = {
			method: "GET",
			url: x,
			headers: { Accept: "application/json" },
			signal: b
		};
		return this.transformOptions(S).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(x, e, (e) => this.processGetComparableProperties(e)));
	}
	processGetComparableProperties(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPropertySummary(e, t, r) {
		let i = this.baseUrl + "/GetPropertySummary";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'address' must be defined and cannot be null.");
		if (i += "address=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'propertyId' cannot be null.");
		t !== void 0 && (i += "propertyId=" + encodeURIComponent(f(t)) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPropertySummary(e)));
	}
	processGetPropertySummary(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	getRpDataAuthorizationUrl(e, t) {
		let r = this.baseUrl + "/GetRpDataAuthorizationUrl";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'returnPage' must be defined and cannot be null.");
		r += "returnPage=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetRpDataAuthorizationUrl(e)));
	}
	processGetRpDataAuthorizationUrl(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTitleReference(e, t) {
		let r = this.baseUrl + "/GetTitleReference", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetTitleReference(e)));
	}
	processGetTitleReference(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	getVendorDetails(e, t) {
		let r = this.baseUrl + "/GetVendorDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'propertyId' must be defined and cannot be null.");
		r += "propertyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetVendorDetails(e)));
	}
	processGetVendorDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	planSuggestion(e, t, r) {
		let i = this.baseUrl + "/PlanSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processPlanSuggestion(e)));
	}
	processPlanSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	storeAccessCode(e, t) {
		let r = this.baseUrl + "/StoreAccessCode", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStoreAccessCode(e)));
	}
	processStoreAccessCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
	suburbSuggestion(e, t, r) {
		let i = this.baseUrl + "/SuburbSuggestion";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
		if (i += "query=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'state' must be defined and cannot be null.");
		i += "state=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processSuburbSuggestion(e)));
	}
	processSuburbSuggestion(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 500 ? A("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : A("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.Employee = "Employee", e.SelfEmployed = "SelfEmployed", e.Unemployed = "Unemployed", e.Retired = "Retired", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.DriversLicense = "DriversLicense", e.AustralianPassport = "AustralianPassport", e.NonAustralianPassport = "NonAustralianPassport", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Australia = "Australia", e.NewSouthWales = "NewSouthWales", e.Other = "Other", e.Queensland = "Queensland", e.Victoria = "Victoria", e.NorthernTerritory = "NorthernTerritory", e.SouthAustralia = "SouthAustralia", e.WesternAustralia = "WesternAustralia", e.AustralianCapitalTerritory = "AustralianCapitalTerritory", e.Tasmania = "Tasmania", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.TitleCertificate = "TitleCertificate", e.CouncilRates = "CouncilRates", e.LandValuationNotice = "LandValuationNotice", e.NationalVendorDeclaration = "NationalVendorDeclaration", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.InPerson = "InPerson", e.Biometric = "Biometric", e.NoPhotoId = "NoPhotoId", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.SquareMetres = "SquareMetres", e.Hectares = "Hectares", e.Acres = "Acres", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Aruba = "Aruba", e.Afghanistan = "Afghanistan", e.Angola = "Angola", e.Anguilla = "Anguilla", e.AlandIslands = "AlandIslands", e.Albania = "Albania", e.Andorra = "Andorra", e.UnitedArabEmirates = "UnitedArabEmirates", e.Argentina = "Argentina", e.Armenia = "Armenia", e.AmericanSamoa = "AmericanSamoa", e.Antarctica = "Antarctica", e.FrenchSouthernTerritories = "FrenchSouthernTerritories", e.AntiguaAndBarbuda = "AntiguaAndBarbuda", e.Australia = "Australia", e.Austria = "Austria", e.Azerbaijan = "Azerbaijan", e.Burundi = "Burundi", e.Belgium = "Belgium", e.Benin = "Benin", e.BonaireSintEustatiusAndSaba = "BonaireSintEustatiusAndSaba", e.BurkinaFaso = "BurkinaFaso", e.Bangladesh = "Bangladesh", e.Bulgaria = "Bulgaria", e.Bahrain = "Bahrain", e.Bahamas = "Bahamas", e.BosniaAndHerzegovina = "BosniaAndHerzegovina", e.SaintBarthelemy = "SaintBarthelemy", e.Belarus = "Belarus", e.Belize = "Belize", e.Bermuda = "Bermuda", e.Bolivia = "Bolivia", e.Brazil = "Brazil", e.Barbados = "Barbados", e.Brunei = "Brunei", e.Bhutan = "Bhutan", e.BouvetIsland = "BouvetIsland", e.Botswana = "Botswana", e.CentralAfricanRepublic = "CentralAfricanRepublic", e.Canada = "Canada", e.CocosKeelingIslands = "CocosKeelingIslands", e.Switzerland = "Switzerland", e.Chile = "Chile", e.China = "China", e.IvoryCoast = "IvoryCoast", e.Cameroon = "Cameroon", e.DemocraticRepublicOfTheCongo = "DemocraticRepublicOfTheCongo", e.RepublicOfTheCongo = "RepublicOfTheCongo", e.CookIslands = "CookIslands", e.Colombia = "Colombia", e.Comoros = "Comoros", e.CapeVerde = "CapeVerde", e.CostaRica = "CostaRica", e.Cuba = "Cuba", e.Curacao = "Curacao", e.ChristmasIsland = "ChristmasIsland", e.CaymanIslands = "CaymanIslands", e.Cyprus = "Cyprus", e.CzechRepublic = "CzechRepublic", e.Germany = "Germany", e.Djibouti = "Djibouti", e.Dominica = "Dominica", e.Denmark = "Denmark", e.DominicanRepublic = "DominicanRepublic", e.Algeria = "Algeria", e.Ecuador = "Ecuador", e.Egypt = "Egypt", e.Eritrea = "Eritrea", e.WesternSahara = "WesternSahara", e.Spain = "Spain", e.Estonia = "Estonia", e.Ethiopia = "Ethiopia", e.Finland = "Finland", e.Fiji = "Fiji", e.FalklandIslands = "FalklandIslands", e.France = "France", e.FaroeIslands = "FaroeIslands", e.Micronesia = "Micronesia", e.Gabon = "Gabon", e.UnitedKingdom = "UnitedKingdom", e.Georgia = "Georgia", e.Guernsey = "Guernsey", e.Ghana = "Ghana", e.Gibraltar = "Gibraltar", e.Guinea = "Guinea", e.Guadeloupe = "Guadeloupe", e.Gambia = "Gambia", e.GuineaBissau = "GuineaBissau", e.EquatorialGuinea = "EquatorialGuinea", e.Greece = "Greece", e.Grenada = "Grenada", e.Greenland = "Greenland", e.Guatemala = "Guatemala", e.FrenchGuiana = "FrenchGuiana", e.Guam = "Guam", e.Guyana = "Guyana", e.HongKong = "HongKong", e.HeardIslandAndMcDonaldIslands = "HeardIslandAndMcDonaldIslands", e.Honduras = "Honduras", e.Croatia = "Croatia", e.Haiti = "Haiti", e.Hungary = "Hungary", e.Indonesia = "Indonesia", e.IsleOfMan = "IsleOfMan", e.India = "India", e.BritishIndianOceanTerritory = "BritishIndianOceanTerritory", e.Ireland = "Ireland", e.Iran = "Iran", e.Iraq = "Iraq", e.Iceland = "Iceland", e.Israel = "Israel", e.Italy = "Italy", e.Jamaica = "Jamaica", e.Jersey = "Jersey", e.Jordan = "Jordan", e.Japan = "Japan", e.Kazakhstan = "Kazakhstan", e.Kenya = "Kenya", e.Kyrgyzstan = "Kyrgyzstan", e.Cambodia = "Cambodia", e.Kiribati = "Kiribati", e.SaintKittsAndNevis = "SaintKittsAndNevis", e.SouthKorea = "SouthKorea", e.Kuwait = "Kuwait", e.Laos = "Laos", e.Lebanon = "Lebanon", e.Liberia = "Liberia", e.Libya = "Libya", e.SaintLucia = "SaintLucia", e.Liechtenstein = "Liechtenstein", e.SriLanka = "SriLanka", e.Lesotho = "Lesotho", e.Lithuania = "Lithuania", e.Luxembourg = "Luxembourg", e.Latvia = "Latvia", e.Macau = "Macau", e.SaintMartin = "SaintMartin", e.Morocco = "Morocco", e.Monaco = "Monaco", e.Moldova = "Moldova", e.Madagascar = "Madagascar", e.Maldives = "Maldives", e.Mexico = "Mexico", e.MarshallIslands = "MarshallIslands", e.NorthMacedonia = "NorthMacedonia", e.Mali = "Mali", e.Malta = "Malta", e.Myanmar = "Myanmar", e.Montenegro = "Montenegro", e.Mongolia = "Mongolia", e.NorthernMarianaIslands = "NorthernMarianaIslands", e.Mozambique = "Mozambique", e.Mauritania = "Mauritania", e.Montserrat = "Montserrat", e.Martinique = "Martinique", e.Mauritius = "Mauritius", e.Malawi = "Malawi", e.Malaysia = "Malaysia", e.Mayotte = "Mayotte", e.Namibia = "Namibia", e.NewCaledonia = "NewCaledonia", e.Niger = "Niger", e.NorfolkIsland = "NorfolkIsland", e.Nigeria = "Nigeria", e.Nicaragua = "Nicaragua", e.Niue = "Niue", e.Netherlands = "Netherlands", e.Norway = "Norway", e.Nepal = "Nepal", e.Nauru = "Nauru", e.NewZealand = "NewZealand", e.Oman = "Oman", e.Pakistan = "Pakistan", e.Panama = "Panama", e.Pitcairn = "Pitcairn", e.Peru = "Peru", e.Philippines = "Philippines", e.Palau = "Palau", e.PapuaNewGuinea = "PapuaNewGuinea", e.Poland = "Poland", e.PuertoRico = "PuertoRico", e.NorthKorea = "NorthKorea", e.Portugal = "Portugal", e.Paraguay = "Paraguay", e.Palestine = "Palestine", e.FrenchPolynesia = "FrenchPolynesia", e.Qatar = "Qatar", e.Reunion = "Reunion", e.Romania = "Romania", e.Russia = "Russia", e.Rwanda = "Rwanda", e.SaudiArabia = "SaudiArabia", e.Sudan = "Sudan", e.Senegal = "Senegal", e.Singapore = "Singapore", e.SouthGeorgiaAndTheSouthSandwichIslands = "SouthGeorgiaAndTheSouthSandwichIslands", e.SaintHelena = "SaintHelena", e.SvalbardAndJanMayen = "SvalbardAndJanMayen", e.SolomonIslands = "SolomonIslands", e.SierraLeone = "SierraLeone", e.ElSalvador = "ElSalvador", e.SanMarino = "SanMarino", e.Somalia = "Somalia", e.SaintPierreAndMiquelon = "SaintPierreAndMiquelon", e.Serbia = "Serbia", e.SouthSudan = "SouthSudan", e.SaoTomeAndPrincipe = "SaoTomeAndPrincipe", e.Suriname = "Suriname", e.Slovakia = "Slovakia", e.Slovenia = "Slovenia", e.Sweden = "Sweden", e.Swaziland = "Swaziland", e.SintMaarten = "SintMaarten", e.Seychelles = "Seychelles", e.Syria = "Syria", e.TurksAndCaicosIslands = "TurksAndCaicosIslands", e.Chad = "Chad", e.Togo = "Togo", e.Thailand = "Thailand", e.Tajikistan = "Tajikistan", e.Tokelau = "Tokelau", e.Turkmenistan = "Turkmenistan", e.EastTimor = "EastTimor", e.Tonga = "Tonga", e.TrinidadAndTobago = "TrinidadAndTobago", e.Tunisia = "Tunisia", e.Turkey = "Turkey", e.Tuvalu = "Tuvalu", e.Taiwan = "Taiwan", e.Tanzania = "Tanzania", e.Uganda = "Uganda", e.Ukraine = "Ukraine", e.UnitedStatesMinorOutlyingIslands = "UnitedStatesMinorOutlyingIslands", e.Uruguay = "Uruguay", e.UnitedStates = "UnitedStates", e.Uzbekistan = "Uzbekistan", e.VaticanCity = "VaticanCity", e.SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines", e.Venezuela = "Venezuela", e.BritishVirginIslands = "BritishVirginIslands", e.USVirginIslands = "USVirginIslands", e.Vietnam = "Vietnam", e.Vanuatu = "Vanuatu", e.WallisAndFutuna = "WallisAndFutuna", e.Samoa = "Samoa", e.Yemen = "Yemen", e.SouthAfrica = "SouthAfrica", e.Zambia = "Zambia", e.Zimbabwe = "Zimbabwe", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.BuiltOn = "BuiltOn", e.VacantLand = "VacantLand", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Lifestyle = "Lifestyle", e.MixedFarming = "MixedFarming", e.Farmlet = "Farmlet", e.Livestock = "Livestock", e.Other = "Other", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Downsizing = "Downsizing", e.Upsizing = "Upsizing", e.Relocating = "Relocating", e.Other = "Other", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.MedicareCard = "MedicareCard", e.CreditCard = "CreditCard", e.AccountStatement = "AccountStatement", e.WaterRatesNotice = "WaterRatesNotice", e.GasElectricityCouncilRates = "GasElectricityCouncilRates", e.ElectoralEnrolment = "ElectoralEnrolment", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e;
}({}), k = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRpDataApiException = !0;
	static isRpDataApiException(e) {
		return e.isRpDataApiException === !0;
	}
};
function A(e, t, n, r, i) {
	throw i ?? new k(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var j = "rpdata";
function M(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var N = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), M(r);
}, P = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[j] || `${e}/${j}`;
}, F = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = P(i), u = c, d = N(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = N(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, I = a({}), L = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = F(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(I.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, R = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(I), c;
	i[0] !== e || i[1] !== t ? (c = [
		"addressSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.addressSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"addressSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, B = (e, t, n, i, a, s, c, l, d, f, p, m, h, g, _, v, y, b, x) => {
	let S = r(47), C = x === void 0 || x, w = o(I), T;
	S[0] !== b || S[1] !== v || S[2] !== y || S[3] !== l || S[4] !== s || S[5] !== f || S[6] !== _ || S[7] !== h || S[8] !== c || S[9] !== a || S[10] !== d || S[11] !== g || S[12] !== m || S[13] !== e || S[14] !== t || S[15] !== n || S[16] !== p || S[17] !== i ? (T = [
		"getComparableProperties",
		e,
		t,
		n,
		i,
		a,
		s,
		c,
		l,
		d,
		f,
		p,
		m,
		h,
		g,
		_,
		v,
		y,
		b
	], S[0] = b, S[1] = v, S[2] = y, S[3] = l, S[4] = s, S[5] = f, S[6] = _, S[7] = h, S[8] = c, S[9] = a, S[10] = d, S[11] = g, S[12] = m, S[13] = e, S[14] = t, S[15] = n, S[16] = p, S[17] = i, S[18] = T) : T = S[18];
	let E = T, D;
	S[19] !== b || S[20] !== w || S[21] !== v || S[22] !== y || S[23] !== l || S[24] !== s || S[25] !== f || S[26] !== _ || S[27] !== h || S[28] !== c || S[29] !== a || S[30] !== d || S[31] !== g || S[32] !== m || S[33] !== e || S[34] !== t || S[35] !== n || S[36] !== p || S[37] !== i ? (D = (r) => {
		let { signal: o } = r;
		return w.getComparableProperties(e, t, n, i, a, s, c, l, d, f, p, m, h, g, _, v, y, b, o);
	}, S[19] = b, S[20] = w, S[21] = v, S[22] = y, S[23] = l, S[24] = s, S[25] = f, S[26] = _, S[27] = h, S[28] = c, S[29] = a, S[30] = d, S[31] = g, S[32] = m, S[33] = e, S[34] = t, S[35] = n, S[36] = p, S[37] = i, S[38] = D) : D = S[38];
	let O = C && !!w, k;
	S[39] !== E || S[40] !== D || S[41] !== O ? (k = {
		queryKey: E,
		queryFn: D,
		enabled: O
	}, S[39] = E, S[40] = D, S[41] = O, S[42] = k) : k = S[42];
	let { data: A, isPending: j, isError: M } = u(k), N;
	return S[43] !== A || S[44] !== M || S[45] !== j ? (N = {
		data: A,
		isPending: j,
		isError: M
	}, S[43] = A, S[44] = M, S[45] = j, S[46] = N) : N = S[46], N;
}, V = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v) => {
		await t.invalidateQueries({ queryKey: [
			"getComparableProperties",
			e,
			n,
			r,
			i,
			a,
			o,
			s,
			c,
			l,
			u,
			d,
			f,
			p,
			m,
			h,
			g,
			_,
			v
		] });
	}, e[0] = t, e[1] = n), n;
}, H = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(I), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPropertySummary",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPropertySummary(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, U = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPropertySummary",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, W = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(I), s;
	n[0] === e ? s = n[1] : (s = ["getRpDataAuthorizationUrl", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getRpDataAuthorizationUrl(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, G = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getRpDataAuthorizationUrl", e] });
	}, e[0] = t, e[1] = n), n;
}, K = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(I), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getTitleReference(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getTitleReference: d,
		getTitleReferencePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, q = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(I), s;
	n[0] === e ? s = n[1] : (s = ["getVendorDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getVendorDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, J = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getVendorDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, Y = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(I), c;
	i[0] !== e || i[1] !== t ? (c = [
		"planSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.planSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, X = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"planSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, Z = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(I), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.storeAccessCode(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		storeAccessCode: d,
		storeAccessCodePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Q = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(I), c;
	i[0] !== e || i[1] !== t ? (c = [
		"suburbSuggestion",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.suburbSuggestion(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"suburbSuggestion",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
};
//#endregion
export { m as EmploymentDetailsEmploymentType, h as IdentityVerificationDocumentSighted, g as IdentityVerificationPlaceOfIssue, _ as IdentityVerificationProofOfOwnershipDocument, v as IdentityVerificationVerificationMethod, y as LandAreaDetailsTotalLandAreaType, b as PhoneNumberCallingCodeCountry, x as PropertyDetailsBuiltOnOrVacantLandType, S as PropertyDetailsRuralType, C as PropertySuggestionItemState, w as RiskAssessmentReasonForTransaction, I as RpDataApiContext, k as RpDataApiException, L as RpDataApiProvider, p as RpDataClient, j as RpDataRoute, T as SecondaryIdentityDocuments, E as SuburbSuggestionItemState, D as TitleReferenceRequestModelState, O as UploadedDocumentDocumentType, R as useAddressSuggestion, B as useGetComparableProperties, H as useGetPropertySummary, W as useGetRpDataAuthorizationUrl, K as useGetTitleReference, q as useGetVendorDetails, z as useInvalidateUseAddressSuggestion, V as useInvalidateUseGetComparableProperties, U as useInvalidateUseGetPropertySummary, G as useInvalidateUseGetRpDataAuthorizationUrl, J as useInvalidateUseGetVendorDetails, X as useInvalidateUsePlanSuggestion, $ as useInvalidateUseSuburbSuggestion, Y as usePlanSuggestion, F as useRpDataClientContext, Z as useStoreAccessCode, Q as useSuburbSuggestion };
